import {
  AnchorButton,
  Callout,
  Classes,
  Collapse,
  Icon,
  Intent,
  Switch,
} from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import * as React from 'react';
import { Tooltip } from 'vet-bones/components';

import { TEST_IDS } from 'src/constants/testIds';
import { usePublishContext } from 'src/containers/PublishProjectDrawer/hooks';
import * as copy from 'src/templates/copy';

export type PublishProjectDrawerFooterProps = {
  handleBack?: () => void;
  handleNext?: () => void;
  isFirstPanel?: boolean;
  /** disables next button and shows tooltip when hovered of this text */
  nextError?: string;
  nextTestId: string;
  nextText: string;
  warningCallout?: string;
};

export const PublishProjectDrawerFooter: React.VFC<
  PublishProjectDrawerFooterProps
> = ({
  handleBack,
  handleNext,
  isFirstPanel,
  nextError = '',
  nextTestId,
  nextText,
  warningCallout = '',
}) => {
  const { doExportProject, isPending, setDoExportProject } =
    usePublishContext();
  return (
    <div
      className={Classes.DRAWER_FOOTER}
      data-testid={TEST_IDS.publishProjectDrawer.footer.container}
    >
      <Collapse isOpen={Boolean(warningCallout)}>
        <Callout
          className={Classes.INTENT_WARNING}
          data-testid={TEST_IDS.publishProjectDrawer.footer.warning}
        >
          <Icon icon={IconNames.WARNING_SIGN} />
          {warningCallout}
        </Callout>
      </Collapse>
      <div>
        <div className="sd-drawer-footer-export">
          <Switch
            checked={doExportProject}
            data-testid={TEST_IDS.publishProjectDrawer.footer.exportSwitch}
            inline
            label={copy.components.publishProjectDrawer.footer.exportProject}
            onChange={() => setDoExportProject((prev) => !prev)}
          />
        </div>
        <div className="sd-drawer-footer-actions">
          <div>
            <AnchorButton
              data-testid={TEST_IDS.publishProjectDrawer.footer.backButton}
              intent={Intent.PRIMARY}
              onClick={() => {
                (document.activeElement as HTMLElement)?.blur();
                handleBack?.();
              }}
              outlined
              text={
                isFirstPanel
                  ? copy.components.publishProjectDrawer.footer.cancel
                  : copy.components.publishProjectDrawer.footer.back
              }
            />
          </div>

          <Tooltip content={nextError} disabled={!nextError}>
            <AnchorButton
              data-testid={nextTestId}
              disabled={Boolean(nextError) || isPending}
              intent={Intent.PRIMARY}
              loading={isPending}
              onClick={() => {
                (document.activeElement as HTMLElement)?.blur();
                handleNext?.();
              }}
              text={nextText}
            />
          </Tooltip>
        </div>
      </div>
    </div>
  );
};
